<div *ngIf="espacoUsado > 0 && plano && espacoUsado >= plano.limiteMb" class="row alert-container">
    <i class="hgi hgi-stroke hgi-alert-02 mr-2"></i> <span>Seu armazenamento está cheio. Atualize seu plano para
        liberar
        mais espaço.</span>
</div>

<div *ngIf="assinatura" class="container p-3 container-informacoes-plano">
    <div class="row mb-3 d-none d-md-flex">
        <div *ngIf="assinatura.plano" class="col text-primary">Plano atual</div>
        <div class="col text-primary">Valor</div>
        <div *ngIf="assinatura.status != 'cancelled' && !assinatura.plano.free" class="col text-primary">Próxima
            Cobrança</div>
        <div class="col text-primary">Situação da Assinatura</div>
        <div *ngIf="assinatura.status != 'cancelled' && (assinatura.plano.isTryout || !assinatura.plano.free)" class="col text-primary">Data de
            vencimento</div>
        <div *ngIf="assinatura.status == 'cancelled'" class="col text-primary">Data de cancelamento</div>
    </div>

    <div class="row bg-white shadow-sm container-informacoes-plano align-items-center p-4 d-none d-md-flex">
        <div *ngIf="assinatura.plano" class="col text">
            <span class="plano-container">
                <i class="hgi hgi-stroke hgi-diamond-02"></i>{{ plano.nome }}
            </span>
        </div>
        <div class="col text">
            {{ assinatura.valor | currency: 'BRL':'symbol' }}
            {{ assinatura.tipoAssinaturaString == 'Anual' ? '/ano' : '/mês' }}
        </div>
        <div *ngIf="assinatura.status != 'cancelled' && !assinatura.plano.free" class="col text">{{ getProximaCobranca()}}</div>
        <div class="col text">{{ getSituacao() }}</div>
        <div *ngIf="assinatura.status != 'cancelled'&& (assinatura.plano.isTryout || !assinatura.plano.free)" class="col text">{{
            assinatura.dataEncerramento | date:
            'dd/MM/yyyy' }}</div>
        <div *ngIf="assinatura.status == 'cancelled'" class="col text">{{ assinatura?.dataCancelamento | date:
            'dd/MM/yyyy' }}</div>
    </div>

    <div class="d-flex d-md-none flex-column bg-white p-3 gap-2 info-mobile">
        <div>
            <span *ngIf="assinatura.plano" class="plano-container">
                <i class="hgi hgi-stroke hgi-diamond-02"></i>{{ plano.nome }}
            </span>
        </div>
        <div class="mt-2">
            <span class="text-primary">Valor: </span>
            <span class="text">
                {{ assinatura.valor | currency: 'BRL':'symbol' }}
                {{ assinatura.tipoAssinaturaString == 'Anual' ? '/ano' : '/mês' }}
            </span>
        </div>
        <div *ngIf="assinatura.status != 'cancelled' && !assinatura.plano.free" class="mt-2">
            <span class="text-primary">Próxima Cobrança:</span>
            <span class="text">
                {{ getProximaCobranca() }}
            </span>
        </div>
        <div class="mt-2">
            <span class="text-primary">Situação da Assinatura:</span>
            <span class="text">{{ getSituacao() }}</span>
        </div>
        <div *ngIf="assinatura.status != 'cancelled' && !assinatura.plano.free && !assinatura.preapprovalId"
            class="mt-2">
            <span class="text-primary">Data de vencimento:</span>
            <span class="text">
                {{ assinatura.dataEncerramento | date: 'dd/MM/yyyy' }}
            </span>
        </div>
        <div *ngIf="assinatura.status == 'cancelled'" class="mt-2">
            <span class="text-primary">Data de cancelamento:</span>
            <span class="text">
                {{ assinatura?.dataCancelamento | date: 'dd/MM/yyyy' }}
            </span>
        </div>
    </div>
</div>

<div *ngIf="showPlanos" class="mt-4">
    <div class="planos-scroll-container d-flex">
        <card-plano [mostrarVoltar]="true" [planoAtual]="assinatura?.plano" [isAnual]="assinatura?.tipoAssinaturaString == 'Anual'"
            [assinatura]="assinatura" [publicoAlvo]="publico">
        </card-plano>
    </div>
</div>


<div class="row mt-4">
    <div *ngIf="validarAssinatura()" class="col d-flex justify-content-center">
        <button class="btn btn-cancelar" (click)="cancelarAssinatura()">Cancelar Assinatura
            <i class="hgi hgi-stroke hgi-cancel-circle-half-dot"></i>
        </button>
    </div>
    <div class="col d-flex justify-content-center">
        <button class="btn primary-white-button" (click)="vizualizarHistorico()">Histórico de Assinatura
            <i class="hgi hgi-stroke hgi-clock-04"></i>
        </button>
    </div>
    <div *ngIf="ehClinica()" class="col d-flex justify-content-center">
        <button class="btn primary-white-button" (click)="vizualizarHistoricoCobrancaExtra()">Cobranças Extras
            <i class="hgi hgi-stroke hgi-time-setting-03"></i>
        </button>
    </div>
    <div *ngIf="assinatura && assinatura.status == 'pending'" class="col d-flex justify-content-center">
        <button class="btn primary-white-button" (click)="vizualizarStatus()">Concluir Pagamento
            <i class="hgi hgi-stroke hgi-arrow-right-02"></i>
        </button>
    </div>
</div>